import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.date.to-string.js";
export var cookie = {
  /**
   * Ecris un cookie
   * @param  {String} cname     Le nom du cookie à écrire
   * @param  {String} cname La valeur du cookie à écrire
   * @param  {Number} exdays La durée en jour avant que le cookie n'expire
   */
  set: function set(cname, cvalue, exdays) {
    var expires;
    if (exdays) {
      var d = new Date();
      d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
      expires = "expires=".concat(d.toUTCString());
    }
    document.cookie = "".concat(cname, "=").concat(cvalue, ";").concat(expires, ";path=/");
  },
  /**
  * Lit un cookie
  * @param  {String} cname     Le nom du cookie à lire
  * @return {String}           Retourne la valeur du cookie, ou une chaîne vide
  */
  get: function get(cname) {
    var name = "".concat(cname, "=");
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) === ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }
    return '';
  },
  /**
  * Supprimer un cookie
  * @param  {String} cname     Le nom du cookie à supprimer
  */
  "delete": function _delete(cname) {
    cookie.set(cname, '', -1);
  }
};